/** @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import { withTheme } from 'styled-components';
import { TooltipWrapper, TooltipTitle, TooltipItemList, TooltipItem } from 'common/components/charts/tooltip/RechartsToolTipStyles';
import { displayNumber } from '../../../../../../common/components/Number';

interface Props {
  active?: boolean;
  payload?: Array<Object>;
  label: number;
  metricLabel: string;
  labelFormatter: (label: number) => string;

  t: any;
  theme: any;
}

function isATick(label) {
  // If the x value is not integer, it's an intersect
  return label % 1 === 0;
}

function AudienceComparisonGraphTooltip({ active, payload, label, labelFormatter, metricLabel, t, theme }: Props) {
  if (active && payload && isATick(label)) {
    const formattedLabel = labelFormatter(label);

    const items = payload.map((i) => {
      if (i.dataKey === 'current') {
        return (
          <TooltipItem key={`tooltip-item-${metricLabel}`} color={i.color}>{metricLabel} : {displayNumber(Number(i.value))}</TooltipItem>
        );
      }
      return null;
    });

    const current = payload[0].payload.current;
    const compared = payload[0].payload.compared;
    const difference = current - compared;

    if (difference > 0) {
      items.push(<TooltipItem key={'tooltip-item-gain'} color={theme.V3.colors.gain.normal}>{t('increase')} : {displayNumber(Number(difference))}</TooltipItem>);
    } else if (difference < 0) {
      items.push(<TooltipItem key={'tooltip-item-loss'} color={theme.V3.colors.loss.normal}>{t('decrease')} : {displayNumber(Number(difference))}</TooltipItem>);
    }

    return (
      <TooltipWrapper>
        <TooltipTitle>{formattedLabel}</TooltipTitle>
        <TooltipItemList>{items}</TooltipItemList>
      </TooltipWrapper>
    );
  }

  return null;
}

export default translate('dashboard')(withTheme(AudienceComparisonGraphTooltip));



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/audienceComparison/AudienceComparisonGraphTooltip.js